export default class TemplateGroupFilter {
  public fromDate: string = null;
  public toDate: string = null;
  public matchIds: string[] = [];
}
